var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as _ from 'lodash';
import renderComponent from './renderComponent';
import { createShorthandFactory } from './factories';
var createComponent = function (_a) {
    var _b = _a.displayName, displayName = _b === void 0 ? 'StardustComponent' : _b, _c = _a.className, className = _c === void 0 ? 'ui-stardust-component' : _c, _d = _a.shorthandPropName, shorthandPropName = _d === void 0 ? 'children' : _d, _e = _a.defaultProps, defaultProps = _e === void 0 ? {} : _e, _f = _a.handledProps, handledProps = _f === void 0 ? [] : _f, propTypes = _a.propTypes, actionHandlers = _a.actionHandlers, focusZoneRef = _a.focusZoneRef, // TODO: setFocusZoneRef
    render = _a.render;
    var mergedDefaultProps = __assign({ as: 'div' }, defaultProps);
    var StardustComponent = function (props) {
        return renderComponent({
            className: className,
            defaultProps: defaultProps,
            displayName: displayName,
            handledProps: _.keys(propTypes).concat(handledProps),
            props: props,
            state: {},
            actionHandlers: actionHandlers,
            focusZoneRef: focusZoneRef,
            render: function (config) { return render(config, props); },
        });
    };
    StardustComponent.create = createShorthandFactory(mergedDefaultProps.as, shorthandPropName);
    StardustComponent.displayName = displayName;
    StardustComponent.propTypes = propTypes; // TODO: generate prop types
    StardustComponent.defaultProps = mergedDefaultProps;
    return StardustComponent;
};
export default createComponent;
